var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("button", {
      staticClass:
        "close-modal fs_md color_main-3 mdi mdi-close cursor-pointer",
      on: { click: _vm.toggleHandler }
    }),
    _c("div", {
      staticClass: "modal-img bgi-basic-contain margin_center margin_bottom_1xl"
    }),
    _c(
      "p",
      {
        staticClass:
          "text text--center font-weight_medium color_dark line-height_lg fs_3md"
      },
      [_vm._v(_vm._s(_vm._("Your password was succesfully changed")))]
    ),
    _c(
      "a",
      {
        staticClass:
          "button button button--color_blue button--width_full fs_md margin_center margin_top_2xl display_block",
        attrs: { href: _vm.url }
      },
      [_vm._v(_vm._s(_vm._("Login")))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15fc08f7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15fc08f7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Modals/SuccessModal.vue
// module id = 535
// module chunks = 0